import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { GlobalContext } from "../context/GlobalContext";
// import DatabaseDropdown from "./dropdown/DatabaseDropdown";
import DomainDropdown from "./dropdown/DomainDropdown";
import UrlDropdown from "./dropdown/UrlDropdown";
import { toast } from "react-toastify";

const DomainFilter = ({
    setData,
    setFilterData,

    selectedDomain,
    setSelectedDomain,

    selectedURL,
    setSelectedURL,
}) => {

    const { API_URL } = useContext(GlobalContext);

    const [domainOptions, setDomainOptions] = useState([]);
    const [urlOptions, setUrlOptions] = useState([]);
    const [loading, setLoading] = useState(false);

    const clearTable = () => {
        setData([]);
        setFilterData([]);
    };

    useEffect(() => {
        loadDomains();
    }, []);



    const loadDomains = async () => {
        try {
            const res = await axios.get(`${API_URL}/filterDomain`);
            setDomainOptions(
                res.data.map(x => ({
                    label: x.domain,
                    value: x.domain
                }))
            );

        } catch (e) {
            console.log(e);
            setDomainOptions([]);

        }

    };

    const loadURLs = async (domain) => {
        if (!domain) {
            setUrlOptions([]);
            return;
        }

        try {
            const res = await axios.get(`${API_URL}/filterCurrentURL/${encodeURIComponent(domain)}`);
            setUrlOptions(
                res.data.map(x => ({
                    label: x.cur_url,
                    value: x.cur_url
                }))
            );

        } catch (e) {
            console.log(e);
            setUrlOptions([]);

        }

    };

    const loadTable = async () => {
        if (!selectedURL || !selectedDomain) {
            clearTable();
            return;
        }

        setLoading(true);
        const toastId = toast.loading("Data processing, please wait...");

        try {

            const response = await axios.post(`${API_URL}/filterContents`, {
                domain: selectedDomain,
                cur_url: selectedURL
            });

            if (response.status === 200) {
                setData(response.data);
                setFilterData(response.data);
                toast.update(toastId, {
                    render: response.data.length > 0 ? "Data transferred successfully." : "No records found...",
                    type: "success",
                    isLoading: false,
                    autoClose: 3000,
                    closeOnClick: true,
                    draggable: true,
                    closeButton: true
                });
            }
        } catch (e) {
            console.log(e);
            clearTable();
        } finally {
            setLoading(false);
        }
    };

    const handleDomainChange = async (option) => {
        if (!option) {
            setSelectedDomain("");
            setSelectedURL("");
            setUrlOptions([]);
            clearTable();
            return;
        }
        setSelectedDomain(option.value);
        setSelectedURL("");
        clearTable();

        await loadURLs(option.value);

    };

    const handleURLChange = (option) => {
        if (!option) {
            setSelectedURL("");
            clearTable();
            return;
        }

        setSelectedURL(option.value);
        clearTable();

    };

    return (

        <div className="d-flex">
            <div className="col-md-4 ms-1">
                <DomainDropdown
                    options={domainOptions}
                    value={selectedDomain}
                    onChange={handleDomainChange}
                />
            </div>

            <div className="col-md-6 ms-5">
                <UrlDropdown
                    options={urlOptions}
                    value={selectedURL}
                    onChange={handleURLChange}
                />
            </div>

            <button
                className="btn btn-light border ms-1"
                onClick={loadTable}
                disabled={loading}
            >
                {loading ? "Loading..." : "GO"}
            </button>
        </div>

    );

};

export default DomainFilter;